export enum WireTypeQuestionValue {
	PoleToPole = 'Pole to pole',
	PoleToBuilding = 'Pole to building',
}
